module.exports = __webpack_public_path__ + "img/Landingpage.20875486.svg";